import './OnbordingComponent.scss';
import { StepperComponent } from '../UI/StepperComponent/StepperComponent';
import { WelcomeComponent } from './Welcome/WelcomeComponent';
import { StepperContent } from '../UI/StepperComponent/model';
import { AppActions } from '../../redux/AppActions';
import { FC, useEffect, useRef } from 'react';
import IngredientsTemplateComponent from './IngredientsTemplate/IngredientsTemplateComponent';
import { UserActions } from '../../redux/UserActions';
import { useNavigate } from 'react-router';
import { useWindowSize } from '../../hooks/useWindowSize';
import { ScreenType } from '../../common/view-model';
import { useAppDispatch } from '../../redux/store';
import { RootState } from '../../redux/AppReducer';
import { useSelector } from 'react-redux';

const OnbordingComponent: FC = ({}) => {
	const dispatch = useAppDispatch();
	const hasLoadIngredientsTemplates = useSelector(
		(state: RootState) =>
			!!(state.appState?.storeState?.templates && state.appState?.storeState?.templates.length > 0)
	);
	const screenType = useSelector((state: RootState) => state.appState.deviceScreen);
	const saveContainerRef = useRef<HTMLDivElement>(null);
	const FULL_SIZE_SCREEN_WIDTH = 743;
	const { width } = useWindowSize();
	const navigate = useNavigate();
	const footerTitle = 'You can always change this configuration in your profile later.';
	const onBordingSteps: StepperContent[] = [
		{
			label: 'Welcome',
			content: (
				<WelcomeComponent
					isMobile={screenType === ScreenType.MOBILE || width === FULL_SIZE_SCREEN_WIDTH}
				/>
			),
			continueBtnLabel: 'Get Started',
			showFooter: true,
			showArrowIcon: screenType === ScreenType.MOBILE || width === FULL_SIZE_SCREEN_WIDTH
		},
		{
			label: 'Ingredients',
			content: <IngredientsTemplateComponent saveContainerRef={saveContainerRef} />,
			continueBtnLabel: 'Continue',
			previousBtnLabel: 'Back',
			continueBtnFunction: () => {
				saveUserIngredientsTemplateId();
				navigate('/landing');
			},
			showFooter: hasLoadIngredientsTemplates
		}
	];
	const setStandAloneLayout = (standAloneLayout: boolean) =>
		dispatch(AppActions.setStandAloneLayout(standAloneLayout));
	const saveUserIngredientsTemplateId = () =>
		dispatch({ type: UserActions.SAVE_USER_INGREDIENTS_TEMPLATE_ID });
	useEffect(() => {
		setStandAloneLayout(true);
	}, []);
	return (
		<div data-testid='onbording-component' className='stepper-container'>
			<StepperComponent
				stepperContent={onBordingSteps}
				footerTitle={footerTitle}
				saveContainerRef={saveContainerRef}
			/>
		</div>
	);
};
export default OnbordingComponent;
